import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Dimmer, Grid, Header } from "semantic-ui-react";
import { server } from "../../config/vars";
import { startLoadNearbyParties } from "../Meta/metaActionCreators";

class NoPartyScreen extends Component {
  componentDidMount() {
    this.props.loadNearbyParties();
  }
  render() {
    return (
      <Dimmer active>
        <Grid style={{ height: "80vh" }}>
          <Grid.Column verticalAlign={"middle"}>
            <Grid.Row>
              <Header as={"h1"} inverted color={"grey"}>
                No party here
              </Header>
              <Button
                size={"massive"}
                positive
                as={"a"}
                href={`${server.uri}/v1/auth/spotify`}
              >
                Get it started!
              </Button>
              {this.props.nearbyParties && this.props.nearbyParties.length > 0 && (
                <>
                  <Header as="h2" inverted color="grey">
                    Suggested parties
                  </Header>
                  {this.props.nearbyParties.map((party) => (
                    <Button
                      as={Link}
                      to={party.url.substring(party.url.indexOf("/"))}
                      key={party.id}
                      positive
                      basic
                      size="big"
                    >
                      {(party.creator.displayName &&
                        `${party.name} by ${
                          party.creator.displayName.split(" ")[0]
                        }`) ||
                        `${party.name}`}
                    </Button>
                  ))}
                </>
              )}
            </Grid.Row>
            <Grid.Row></Grid.Row>
          </Grid.Column>
        </Grid>
      </Dimmer>
    );
  }
}

NoPartyScreen.propTypes = {
  nearbyParties: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    nearbyParties: state.meta.nearbyParties,
    loading: state.meta.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadNearbyParties: () => dispatch(startLoadNearbyParties()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NoPartyScreen);
